module.exports = __webpack_public_path__ + "img/pvc_dots_dark_grey.a25afe81.png";